module.exports = __webpack_public_path__ + "img/banner2.07c52875.jpg";